export default "__VITE_ASSET__DBtBZGrD__"